import React, { useEffect, useRef, useState } from "react";
import {
  AttachmentSection,
  Button,
  Divider,
  DocumentsList,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { WADocType } from "../../../../../../assets/data/projectData";
import { RecordStatus } from "../../../../../../assets/data/enumData";
//////
import { useDispatch, useSelector } from "react-redux";
import { updateEmployee } from "../../../../../../redux/slices/employee/employeeApi";
import {
  getEmployeeByUiidStart,
  updateEmployeeStart,
} from "../../../../../../redux/slices/employee/employeeSlice";

import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import useDropdownData from "../../../../../../hooks/useDropdownData";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { transformFiles } from "../../../../../../utils/transformFiles";

const EVerifyModal = ({ isOpen, onClose, edit, selectedRow }) => {
  const dispatch = useDispatch();

  const containerRef = useRef(null);
  const [validationRules, setValidationRules] = useState({});
  const { employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );

  const { uiid: employeeUiid, passport } =
    currentEmployee.employeeDetails || {};

  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const organizationId = loginUserData?.organizationId.uiid;
  ////////

  //////////////////
  //initial Form Data

  const initialFormData = {
    eVerificationCaseNumber: "",
    eVerificationDate: "",
    eVerificationStatus: "",
    eVerifiedBy: "",
    eVerifiedDocument: "",
    expiryDate: "",
    attachments: [
      {
        id: uuidv4(),
        // attachmentName: "",
        // attachmentComments: "",
        chooseFiles: [],
      },
    ],
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  useEffect(() => {
    const baseRules = {
      eVerificationCaseNumber: { type: "text", required: true },
      attachments: [{ chooseFiles: { type: "file" } }],
    };
    setValidationRules(baseRules);
  }, [formData.attachments.length]);

  ///////////////////////////////////////////////////
  //handel Attachment Error
  ///////////////////////////////////////////////////

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  ///////////////////////////////////////////////////
  //handel Attachment Error end
  ///////////////////////////////////////////////////

  ///////////////////Handel Save//////////////////////

  const handleSaveEVerify = () => {
    const isValid = validateAllFields();

    if (isValid) {
      const userFormData = {
        caseNum: formData.eVerificationCaseNumber,
        date: formData.eVerificationDate,
        status: formData.eVerificationStatus,
        verifiedBy: formData.eVerifiedBy,
        verifiedDoc: formData.eVerifiedDocument,
        expiryDate: formData.expiryDate,
      };
      const submissionData = filterEmptyValues(userFormData);
      const cleanAttachments = formData.attachments.filter(
        (att) =>
          att.attachmentName.trim() !== "" ||
          att.attachmentComments.trim() !== "" ||
          (att.chooseFiles && att.chooseFiles.length > 0),
      );
      dispatch(
        updateEmployeeStart({
          coll: "Employee",
          uiid: employeeProfileUiid,
          tab: "eVerifiyTab",
          ret: "eVerify",
          tPath: edit ? "" : "eVerify",
          patchId: edit ? selectedRow?._id : "",
          payload: [
            {
              type: edit ? "SET" : "PUSH",
              // value: { eVerify: submissionData },
              value: {
                [edit ? "eVerify.$[elem]" : "eVerify"]: submissionData,
              },
            },
          ],
          onSuccess: async (payload) => {
            if (cleanAttachments?.length) {
              dispatch(
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  uiid: employeeProfileUiid,
                  entity: "employees",
                  category: "eVerify",
                  coll: "Employee", //WorkAuth
                  doc: cleanAttachments.flatMap((doc) =>
                    doc.chooseFiles.map((file) => {
                      file.id = doc.id;
                      return file;
                    }),
                  ),
                  onSuccess: async (fileData) => {
                    dispatch(
                      addDocumentStart({
                        coll: "Document",
                        refColl: "Employee",
                        refId: employeeProfileUiid,
                        refField: "eVerify.$[elem].documents",
                        refPatchId: edit
                          ? selectedRow?._id
                          : payload?.data?.targetPatchId,

                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              parent: { employee: employeeProfileUiid },
                              addedBy: loginUserUiid,
                              docType: "Everify",
                              ref: {
                                id: employeeProfileUiid, // parent doc uiid this doc belongs to
                                entity: "Employee", // collection name this doc belongs to
                                path: `eVerify.${
                                  edit
                                    ? selectedRow?._id
                                    : payload?.data?.targetPatchId
                                }.documents`,
                              },
                              file: cleanAttachments.map((obj) => ({
                                name: obj.attachmentName,
                                comments: obj.attachmentComments,
                                keys: fileData
                                  .filter(
                                    (file) =>
                                      file?.fileRefId === obj.id && file.key,
                                  ) // match and ensure key exists
                                  .map((file) => file.key),
                              })),
                            },
                          ],
                        },
                        //onSuccess: handleModalClose,
                        onSuccess: async () => {
                          dispatch(
                            getEmployeeByUiidStart({
                              uiid: employeeProfileUiid,
                              tab: "eVerifiyTab",
                              ret: "eVerify",
                              ref: "eVerifyDoc",
                            }),
                          );
                          handleModalClose();
                        },
                      }),
                    );
                  },
                }),
              );
            } else {
              dispatch(
                getEmployeeByUiidStart({
                  uiid: employeeProfileUiid,
                  tab: "eVerifiyTab",
                  ret: "eVerify",
                  ref: "eVerifyDoc",
                }),
              );
              handleModalClose();
            }
          },
        }),
      );
    } else {
      showToast("Please fill in all the required fields before saving", "error");
    }
  };
  ///////////////////handel save end////////////////////

  const handleModalClose = () => {
    onClose(true);
    setFormData(initialFormData);
  };

  ///////////////////////////////////////////////////
  ///// Get select data form server
  ///////////////////////////////////////////////////
  const {
    data: eVerifiedByOptions,
    searchValue: eVerifiedBySearch,
    handleSearch: handleEVerifiedBySearch,
    resetSearch: resetEVerifiedBySearch,
    handleScroll: handleEVerifiedByScroll,
  } = useDropdownData("eVerifiedBy", 5, {}, { orgId: organizationId });
  ///////////////////////////////////////////////////
  ///// Get select data form server
  ///////////////////////////////////////////////////
  useEffect(() => {
    if (edit) {
      handleChange("eVerificationCaseNumber", selectedRow?.caseNum);
      handleChange("eVerificationDate", selectedRow?.date);
      handleChange("eVerifiedBy", selectedRow?.verifiedBy);
      handleChange("expiryDate", selectedRow?.expiryDate);
      handleChange("eVerifiedDocument", selectedRow?.verifiedDoc);
      handleChange("eVerificationStatus", selectedRow?.status);
    } else {
      setFormData(initialFormData);
    }
  }, [edit, selectedRow]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ADD E-VERIFY "
      width="max-w-7xl"
    >
      <div>
        {/* <div className="grid grid-cols-3 gap-x-6 gap-y-6 px-2 max-w-7xl"> */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4 max-w-7xl">
          <FormFieldSet
            type="text"
            title="E-Verification Case Number"
            placeholder="Enter E-Verification Case Number"
            value={formData.eVerificationCaseNumber}
            onChange={(value) => handleChange("eVerificationCaseNumber", value)}
            error={errors.eVerificationCaseNumber}
          />
          <FormFieldSet
            type="datepicker"
            title="E-Verification Date"
            placeholder="Select E-Verification Date"
            value={formData.eVerificationDate}
            onChange={(value) => handleChange("eVerificationDate", value)}
            error={errors.eVerificationDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title="E-Verification Status"
            placeholder="Select E-Verification Status"
            value={formData.eVerificationStatus}
            onChange={(value) => handleChange("eVerificationStatus", value)}
            error={errors.eVerificationStatus}
            options={RecordStatus}
          />

          <FormFieldSet
            type="select"
            title="E-Verified By"
            keyname={"eVerifiedBy"}
            placeholder="Select Immigration Manager"
            value={formData.eVerifiedBy}
            onChange={(value) => handleChange("eVerifiedBy", value)}
            options={eVerifiedByOptions}
            showSearch
            searchValue={eVerifiedBySearch}
            onSearch={(value) => handleEVerifiedBySearch(value)}
            onClose={resetEVerifiedBySearch}
            error={errors.eVerifiedBy}
            icon={"add"}
            refData={containerRef}
            handleScroll={() => handleEVerifiedByScroll(containerRef)}
          />

          <FormFieldSet
            type="select"
            title="E-Verified Document"
            placeholder="Select E-Verified Document"
            value={formData.eVerifiedDocument}
            onChange={(value) => handleChange("eVerifiedDocument", value)}
            error={errors.eVerifiedDocument}
            options={WADocType}
            showSearch
          />
          <FormFieldSet
            type="datepicker"
            title="Expiry Date"
            placeholder="Select Expiry Date"
            value={formData.expiryDate}
            onChange={(value) => handleChange("expiryDate", value)}
            error={errors.expiryDate}
            showDropdown={false}
          />
        </div>
        <div className="mt-4 mb-1">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title="Attachments" tag="h6" />
              </div>
            }
          />
        </div>
        <Divider />
        {edit && (
          <DocumentsList
            data={transformFiles(selectedRow?.documents || [])}
            type="inner"
          />
        )}
        <AttachmentSection
          attachments={formData.attachments}
          onChange={(newAttachments) =>
            setFormData({ ...formData, attachments: newAttachments })
          }
          getAttachmentError={getAttachmentError}
          showNameField={true}
          showCommentsField={true}
        />
        <div className="flex gap-3 justify-end my-14 ">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title="Save" onClick={handleSaveEVerify} />
        </div>
      </div>
    </Modal>
  );
};

export default EVerifyModal;
